import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getTextAreaTestIds = createTestIds('text-area', ['control', ...elements] as const);
